import React from "react";
import "./footer.css";
import logo from "../../images/agent-rai-logo.svg";
const FooterSection = () => {
  return (
    <footer>
      <div className="footer__wrapper">
        <div className="container">
          <div className="footer-inner">
            <div className="footer-items">
              <div className="footer-logo">
                <img src={logo} alt="agent-sketch-logo" />
              </div>
              <div className="list-name">
                <p>
                  Enabling trustworthy and safe AI systems with ethical
                  guardrails, real-time scoring, risk management, and quality
                  assurance for businesses
                </p>
              </div>
            </div>
            <div className="footer-end">
              <div style={{ alignItems: "center" }}>
                <div className="col-12 col-sm-7 col-md-7 col-lg-7">
                  <div className="footer-links">
                    <p>Legal</p>
                    <p>Privacy Policy</p>
                    <p>Terms & Conditions</p>
                  </div>
                </div>
                <div className="col-12 col-sm-5 col-md-5 col-lg-5 copyright">
                  <p>Copyright 2026. All rights reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
